<ion-card
  class="border-r10 ion-margin-horizontal ion-margin-bottom ion-no-margin card-white-background-color"
>
  <div class="ion-text-end" *ngIf="upcomingFlight?.isPast">
    <ion-chip
      *ngIf="upcomingFlight?.isPast === 'PAST'"
      class="secondary-chip fs-2 font600"
      >{{ upcomingFlight?.isPast }}</ion-chip
    >
    <ion-chip
      *ngIf="upcomingFlight?.isPast === 'UPCOMING'"
      class="primary-chip fs-2 font600"
      >{{ upcomingFlight?.isPast }}</ion-chip
    >
  </div>
  <ion-card-content class="d-block ion-no-padding ion-padding">
    <div
      class="ion-float-start maxw70 fs-2 font500 text-wrap card-primary-text-color d-flex"
    >
      <img
        *ngIf="
          upcomingFlight?.airline?.airline_logo ||
          upcomingFlight?.data?.airline?.airline_logo
        "
        [src]="
          upcomingFlight?.airline?.airline_logo ||
          upcomingFlight?.data?.airline?.airline_logo
        "
        class="airline-logo marr10"
      />
      {{ upcomingFlight?.flight_no }} - {{ upcomingFlight?.airline_name }}
    </div>
    <div class="ion-float-end fs-2 font600 text-wrap card-primary-text-color">
      {{ upcomingFlight?.depDayDate | smartdate : "mediumDate" }}
    </div>
    <ion-grid class="ion-no-padding content">
      <ion-row class="w100 ion-justify-content-between ion-align-items-center">
        <ion-col class="ion-no-padding" size="3">
          <h2 class="fs-5 font700 card-primary-text-color">
            {{ upcomingFlight?.src }}
          </h2>
          <div *ngIf="upcomingFlight?.originAirport?.scheduled_dep">
            <p
              class="{{
                isExpectedActualDep(upcomingFlight?.originAirport)
                  ? 'strike'
                  : ''
              }}"
            >
              {{ getTime(upcomingFlight?.originAirport?.scheduled_dep) }}
            </p>
            <p *ngIf="isExpectedActualDep(upcomingFlight?.originAirport)">
              {{ getTime(isExpectedActualDep(upcomingFlight?.originAirport)) }}
            </p>
          </div>
          <div *ngIf="!upcomingFlight?.originAirport?.scheduled_dep">
            <p>
              {{
                getTime(upcomingFlight?.originAirport?.expected_dep) ||
                  getTime(upcomingFlight?.originAirport?.actual_dep) ||
                  "-"
              }}
            </p>
          </div>
        </ion-col>
        <ion-col class="ion-no-padding ion-text-center" size="6">
          <ion-label
            class="fs-2 font600 ion-text-capitalize card-green-text-color"
            *ngIf="
              upcomingFlight?.status?.toLowerCase().trim() === 'on-time';
              else delayed
            "
            >{{ upcomingFlight?.status }}</ion-label
          >
          <ng-template #delayed>
            <ion-label
              class="fs-2 font600 ion-text-capitalize card-yellow-text-color"
              *ngIf="
                upcomingFlight?.status?.toLowerCase().trim() === 'delayed';
                else cancelled
              "
              >{{ upcomingFlight?.status }}</ion-label
            >
          </ng-template>
          <ng-template #cancelled>
            <ion-label
              class="fs-2 font600 ion-text-capitalize card-red-text-color"
              *ngIf="
                upcomingFlight?.status?.toLowerCase().trim() === 'cancelled';
                else otherStatus
              "
              >{{ upcomingFlight?.status }}</ion-label
            >
          </ng-template>
          <ng-template #otherStatus>
            <ion-label
              class="fs-2 font600 ion-text-capitalize card-primary-text-color"
              >{{ upcomingFlight?.status }}</ion-label
            >
          </ng-template>
          <span class="flight-gif">
            <img src="/assets/icons/flight.gif" class="font20" alt="flight" />
          </span>
          <p class="fs-2 font500 card-secondary-text-color">
            {{
              upcomingFlight?.duration ||
                calculateTotalTime(
                  upcomingFlight?.originAirport?.expected_dep,
                  upcomingFlight?.destinationAirport?.expected_arr
                )
            }}
          </p>
        </ion-col>
        <ion-col class="ion-no-padding ion-text-right" size="3">
          <h2 class="fs-5 font700 card-primary-text-color">
            {{ upcomingFlight?.dest }}
          </h2>
          <div *ngIf="upcomingFlight?.destinationAirport?.scheduled_arr">
            <p
              class="{{
                isExpectedActualArr(upcomingFlight?.destinationAirport)
                  ? 'strike'
                  : ''
              }}"
            >
              {{ getTime(upcomingFlight?.destinationAirport?.scheduled_arr) }}
            </p>
            <p *ngIf="isExpectedActualArr(upcomingFlight?.destinationAirport)">
              {{
                getTime(
                  isExpectedActualArr(upcomingFlight?.destinationAirport)
                ) || "-"
              }}
            </p>
          </div>
          <div *ngIf="!upcomingFlight?.destinationAirport?.scheduled_arr">
            <p>
              {{
                getTime(upcomingFlight?.destinationAirport?.expected_arr) ||
                  getTime(upcomingFlight?.destinationAirport?.actual_arr) ||
                  "-"
              }}
            </p>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-grid class="ion-no-margin ion-no-padding card-footer" fixed>
      <ion-row class="ion-justify-content-between">
        <ion-col size="5">
          <ion-grid class="ion-no-margin ion-no-padding" fixed>
            <ion-row class="grey-text">
              <ion-col size="6">
                <div class="card-secondary-text-color fs-2 font500">
                  {{ "shared.flight_card.terminal" | translate }}
                </div>
                <div class="card-secondary-text-color fs-2 font500">
                  {{ upcomingFlight?.originAirport?.terminal || "-" }}
                </div>
              </ion-col>
              <ion-col size="6">
                <div class="card-secondary-text-color fs-2 font500">
                  {{ "shared.flight_card.gate" | translate }}
                </div>
                <div class="card-secondary-text-color fs-2 font500">
                  {{ upcomingFlight?.originAirport?.gate || "-" }}
                </div>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-col>
        <ion-col size="2"> </ion-col>
        <ion-col size="5">
          <ion-grid class="ion-no-margin ion-no-padding" fixed>
            <ion-row class="grey-text">
              <ion-col size="6">
                <div class="card-secondary-text-color fs-2 font500">
                  {{ "shared.flight_card.terminal" | translate }}
                </div>
                <div class="card-secondary-text-color fs-2 font500">
                  {{ upcomingFlight?.destinationAirport?.terminal || "-" }}
                </div>
              </ion-col>
              <ion-col size="6">
                <div class="card-secondary-text-color fs-2 font500">
                  {{ "shared.flight_card.belt" | translate }}
                </div>
                <div class="card-secondary-text-color fs-2 font500">
                  {{ upcomingFlight?.destinationAirport?.gate || "-" }}
                </div>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card-content>
</ion-card>
